















































import {Component, Vue} from 'vue-property-decorator';
import Map from "@/components/Map.vue";
import Message from "@/components/Message.vue";
import Timeline from "@/components/Timeline.vue";
import MusicList from "@/components/MusicList.vue";
import anime from "animejs";

@Component({
    components: {
        Timeline,
        Message,
        Map,
        MusicList,
    }
})

export default class App extends Vue {

    private windowInnerWidth:number = 0;
    private windowInnerHeight:number = 0;

    get currentYear(): number {
        let today = new Date();
        let year = today.getFullYear();

        return year;
    }

    created() {
        this.windowInnerWidth = window.innerWidth;
        this.windowInnerHeight = window.innerHeight;

        window.onresize = () => {
            if (this.windowInnerWidth == window.innerWidth) {
                return;
            }

            this.windowInnerWidth = window.innerWidth;
            this.windowInnerHeight = window.innerHeight;
        }
    }

}
